import Card from "../../UI/Card";
import useMandatPrelevementFichier from "../../../hooks/use-mandat-prelevement-fichier";
import { currencyFormatter, dateConvert } from "../../../api/Functions";
import { Table } from "../../UI/Table";
import ButtonAction from "../../UI/ButtonAction";
import { FolderArrowDown, Trash } from "../../UI/Icons";
import { useState } from "react";
import Spinner from "../../UI/Spinner";
import { useConfirm } from "../../../hooks/use-confirm";
import DocumentDownloader from "../../UI/DocumentDownloader";

export default function HistoriquePrelevementForm() {
  const {
    mandatPrelevementFichiers,
    isLoading,
    getBordereauUrl,
    deleteMandatPrelevementFichier,
  } = useMandatPrelevementFichier();
  const [downloadingId, setDownloadingId] = useState(null);
  const [Confirm, openConfirm] = useConfirm();

  async function handleDownloadBordereau(fichierId, setSignedUrl) {
    setDownloadingId(fichierId);
    try {
      const url = await getBordereauUrl(fichierId);
      setSignedUrl(url);
    } catch (error) {
      console.error("Erreur lors du téléchargement du bordereau:", error);
    } finally {
      setDownloadingId(null);
    }
  }

  async function handleDelete(fichierId) {
    try {
      await deleteMandatPrelevementFichier(fichierId);
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
    }
  }

  if (isLoading) {
    return (
      <div className="text-center paddingT20">
        <Spinner />
      </div>
    );
  }

  return (
    <DocumentDownloader>
      {(setSignedUrl) => (
        <div>
          <Confirm
            onAnswer={(ok, fichierId) => {
              if (ok) {
                handleDelete(fichierId);
              }
            }}
          >
            <p>
              Voulez-vous vraiment supprimer ce prélèvement ? Vous ne pourrez
              pas revenir en arrière.
            </p>
          </Confirm>
          <h2 className="text-center">Historique des prélèvements</h2>
          <p className="marginB10 secondaryText">
            Retrouvez ci-dessous l'ensemble des fichiers de prélèvements générés
            ainsi que les bordereaux associés.
          </p>
          <Card>
            <Table>
              <Table.Header>
                <Table.Column>Date de prélèvement</Table.Column>
                <Table.Column align="right">Locataires</Table.Column>
                <Table.Column align="right">Montant total</Table.Column>
                <Table.Column align="center">Actions</Table.Column>
              </Table.Header>
              <Table.Body>
                {mandatPrelevementFichiers.length > 0 ? (
                  mandatPrelevementFichiers.map((fichier) => (
                    <Table.Row key={fichier.id}>
                      <Table.Cell>
                        {dateConvert(fichier.date_prelevement)}
                      </Table.Cell>
                      <Table.Cell align="right">
                        {fichier.nb_locataires}
                      </Table.Cell>
                      <Table.Cell align="right">
                        {currencyFormatter(fichier.montant_total)}
                      </Table.Cell>
                      <Table.Cell align="center">
                        <div className="flex gap10 justify-center">
                          {downloadingId === fichier.id ? (
                            <Spinner size="small" />
                          ) : (
                            <ButtonAction
                              onClick={() =>
                                handleDownloadBordereau(
                                  fichier.id,
                                  setSignedUrl,
                                )
                              }
                              logo={<FolderArrowDown stroke="#0C69F5" />}
                            />
                          )}
                          <ButtonAction
                            onClick={() => openConfirm(fichier.id)}
                            logo={<Trash />}
                          />
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell
                      colSpan="100%"
                      className="text-center secondaryText paddingT20"
                    >
                      Aucun prélèvement
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </Card>
        </div>
      )}
    </DocumentDownloader>
  );
}
